<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="panel">
    <div class="panel-body">
      <div class="divide-slate-200">
        <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.gross_weight") }}:
            </dt>
            <dd class="content-data">{{ container.gross_weight }} Kg</dd>
          </div>
          <div class="sm:col-span-2">
            <h3 class="px-3"></h3>
            <dt class="label-data">{{ $t("model.container.net_weight") }}:</dt>
            <dd class="content-data">{{ container.net_weight }} Kg</dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.exporter_process_crop_category") }}
            </dt>
            <dd class="content-data">
              {{ container.category_name }}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.exporter_process_crop_variety") }}
            </dt>
            <dd class="content-data">
              {{ container.variety_name }}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.exporter_process_brand") }}:
            </dt>
            <dd class="content-data">
              {{ container.brand_name }}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.agro_exporter") }}:
            </dt>
            <dd class="content-data">
              {{ container.agro_exporter.name }}
            </dd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "PHProductionFinalPackingListSimplifiedContainerInfo",
  data() {
    return {};
  },
  props: {
    container: {
      type: Object,
      required: true,
    },
  },
};
</script>
